import { render } from "./KeywordsComponent.vue?vue&type=template&id=004363be"
import script from "./KeywordsComponent.vue?vue&type=script&lang=js"
export * from "./KeywordsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__